import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, LoadingSkeleton } from "@/components/shared/States";
import { Button } from "@/components/ui/button";
import { Brain, Flame, Lightbulb, AlertTriangle, Sparkles, RefreshCw } from "lucide-react";

export default function Insights() {
  const [insights, setInsights] = useState(null);
  const load = async () => { setInsights(null); try { const { data } = await api.post("/ai/insights"); setInsights(data.insights || []); } catch { setInsights([]); } };
  useEffect(() => { load(); }, []);

  const meta = (type) => ({
    risk: { Icon: AlertTriangle, tint: "text-red-500 bg-red-50", ring: "border-red-100" },
    signal: { Icon: Lightbulb, tint: "text-amber-500 bg-amber-50", ring: "border-amber-100" },
    followup: { Icon: Flame, tint: "text-orange-500 bg-orange-50", ring: "border-orange-100" },
    opportunity: { Icon: Sparkles, tint: "text-violet-500 bg-violet-50", ring: "border-violet-100" },
  }[type] || { Icon: Sparkles, tint: "text-violet-500 bg-violet-50", ring: "border-violet-100" });

  return (
    <div>
      <PageHeader title="Revenue Intelligence" subtitle="AI-surfaced insights across your pipeline" icon={Brain}
        actions={<Button variant="outline" onClick={load}><RefreshCw className="h-4 w-4 mr-1" />Refresh</Button>} />
      {insights === null ? <LoadingSkeleton rows={4} /> : (
        <div className="grid md:grid-cols-2 gap-3">
          {insights.map((ins, i) => { const { Icon, tint, ring } = meta(ins.type); return (
            <div key={i} className={`rounded-2xl bg-white border ${ring} p-5`}>
              <div className="flex items-start gap-3">
                <div className={`h-10 w-10 rounded-xl flex items-center justify-center shrink-0 ${tint}`}><Icon className="h-5 w-5" /></div>
                <div className="flex-1"><div className="flex items-center justify-between"><h3 className="font-semibold text-slate-900">{ins.title}</h3><span className="text-[11px] font-semibold text-slate-400">{ins.confidence}%</span></div><p className="text-sm text-slate-500 mt-1">{ins.detail}</p><div className="mt-3 flex items-center justify-between"><span className="text-xs font-semibold text-emerald-600">{ins.impact}</span><Button size="sm" variant="ghost" className="h-7 text-xs text-[#7C3AED]">Review</Button></div></div>
              </div>
            </div>
          ); })}
          {insights.length === 0 && <div className="text-sm text-slate-400 py-10 col-span-2 text-center">No insights available right now.</div>}
        </div>
      )}
    </div>
  );
}
